export default {
    'diagram3': {

    }
}


// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5a/diagram3/i18n/en.js